import ClassicQuizQuestionModel from "../ClassicQuizQuestionModel";

export default class ClassicQuizQuestionsReportModel {
  public questionId: string = null;
  public questionModel: ClassicQuizQuestionModel = null;
  public wrong: string = null;
  public correct: string = null;
  public skipped: string = null;
  public total: string = null;
}
